import { useToast, UseToastOptions } from "@chakra-ui/react";
import { useCallback } from "react";

export function useErrorToast() {
  const toast = useToast();
  return useCallback(
    (props: UseToastOptions = {}) => {
      toast({
        title: "Something went wrong",
        status: "error",
        variant: "neutral",
        ...props,
      });
    },
    [toast],
  );
}
